import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfImageMediaIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * CcfImageMediaIcon component used to display media image icon
 * @param props - CcfImageMediaIconProps
 * @example - <CcfImageMediaIcon />
 * @returns SVG of Media image icon
 */
export function CcfImageMediaIcon(props: CcfImageMediaIconProps) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <g id="Media/Image">
        <g id="Vector">
          <path
            d="M12.8331 0H1.16632C0.524512 0 -0.000488281 0.525 -0.000488281 1.16681V12.8336C-0.000488281 13.4754 0.524512 14.0004 1.16632 14.0004H12.8331C13.4749 14.0004 13.9999 13.4754 13.9999 12.8336V1.16681C13.9999 0.525 13.4749 0 12.8331 0ZM12.8331 1.16681V11.7836L10.2663 8.45862C9.97451 7.99181 9.62451 7.93363 9.39132 7.93363C8.92451 7.93363 8.57451 8.28363 8.45814 8.40044L7.81632 9.10044L4.72451 6.12544C4.4327 5.71725 4.14132 5.65862 3.9077 5.65862C3.44089 5.65862 3.09089 6.00863 2.97451 6.12544L1.16632 7.93363V1.16681H12.8331ZM12.1918 12.8332H5.77495L9.33314 9.15819L12.1918 12.8332ZM1.16676 9.625L3.84995 6.825L6.99995 9.91681L4.14176 12.8336H1.16676V9.625Z"
            fill={props.fillColor ? props.fillColor : '#0079BA'}
          />
          <path
            d="M10.8499 4.25819C10.8499 5.06406 10.1968 5.71637 9.39176 5.71637C8.58676 5.71637 7.93357 5.06319 7.93357 4.25819C7.93357 3.45231 8.58676 2.8 9.39176 2.8C10.1968 2.8 10.8499 3.45319 10.8499 4.25819Z"
            fill={props.fillColor ? props.fillColor : '#0079BA'}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfImageMediaIcon;
